module.exports = __webpack_public_path__ + "static/img/Chao-Ching Fu.jpg";